<script>
import Layout from '@/Shared/Layout'
export default { layout: Layout }
</script>

<script setup>
import { onMounted, onUnmounted } from 'vue'
import { Head } from '@inertiajs/inertia-vue3'
import { replaceS3path, formatYen, removeLineBreaks } from '@/Shared/helper.js'
import ButtonRounded from '@/Shared/Buttons/ButtonRounded'
import Sidebar from '@/Shared/Sidebar/SidebarBanners/'
import Breadcrumbs from '@/Shared/Breadcrumbs'
import usePref from '@/Shared/usePref.js'

const props = defineProps({
  bookInfo: Array,
  pref: Object,
})


const authorLoop = function () {
  let r = []
  const bookReviewAuthor = props.bookInfo[0].bookReviewAuthor ? props.bookInfo[0].bookReviewAuthor : 'A&F出版より'
  const authorArray = bookReviewAuthor.split(/\n|\r\n?/)
  const bookReview = props.bookInfo[0].bookReviewLong ? props.bookInfo[0].bookReviewLong : props.bookInfo[0].bookReviewShort
  const reviewArray = bookReview.split(/\n|\r\n?/)
  authorArray.forEach((e, index) => {
    let t = {}
    t.author = e
    t.review = reviewArray[index]
    r.push(t)
  })
  return r
}

const reviewStatus = () => {
  return Boolean(props.bookInfo[0].bookReviewLong || props.bookInfo[0].bookReviewShort)
}
const generateLabel = () => {
  const r = (props.bookInfo[0].bookSlug == 'catalog') ? 'デジタルカタログを読む' : '試し読みはこちら'
  return r
}
onMounted(() => {
  usePref(props.pref)
})

onUnmounted(() => {})
</script>

<template>
  <div class="book-detail">
    <Head :title="bookInfo[0].bookName">
      <meta name="description" :content="removeLineBreaks(bookInfo[0].bookIntroductionTitle)" />
      <meta property="og:title" :content="bookInfo[0].bookName" />
      <meta property="og:description" :content="removeLineBreaks(bookInfo[0].bookIntroductionTitle)" />
      <meta property="og:image" :content="replaceS3path(bookInfo[0].bookThumb)" />
    </Head>
    <div class="detail-container">
      <Breadcrumbs category="book" :title="bookInfo[0].bookName" />

      <div class="detail-contents">
        <div class="main">
          <img :src="replaceS3path(bookInfo[0].bookThumb)" :alt="bookInfo[0].bookName" class="mx-auto mt-[30px] sm:mt-[50px] rounded-[20px]" />
          <div class="main-contents">
            <div v-if="bookInfo[0].bookNew == true" class="new">NEW</div>
            <div class="text-[10px] mb-[5px]">{{ bookInfo[0].bookCode }}</div>

            <h1 class="text-[24px] font-bold mb-[15px] leading-[1.3]">{{ bookInfo[0].bookName }}</h1>

            <div class="authors text-[14px] sm:text-[15px] mb-[10px] leading-[1.6]">
              <span v-html="bookInfo[0].bookAuthorName" />
              <br v-if="bookInfo[0].bookTranslatorName" />
              <span v-if="bookInfo[0].bookTranslatorName" v-html="bookInfo[0].bookTranslatorName" />
            </div>

            <div class="text-[16px] sm:text-[18px] mb-[30px] sm:mb-[40px]">
              <span v-html="formatYen(bookInfo[0].bookPrice)" />
              <small class="text-[75%]">（税込）</small>
            </div>

            <div class="mb-[50px]">
              <h3 class="text-[16px] sm:text-[17px] font-bold text-afgreen mb-[15px] leading-[1.6]" v-html="bookInfo[0].bookIntroductionTitle" />
              <p class="leading-[2]" v-html="bookInfo[0].bookIntroduction" />
            </div>

            <div v-if="reviewStatus()" class="mb-[50px]">
              <div v-for="author in authorLoop()" :key="author.author" class="mb-[30px] sm:mb-[50px]">
                <h4 class="text-[14px] sm:text-[15px] font-bold pb-[12px] mb-[10px] leading-[1.4] border-b border-b-black border-dotted">{{ author.author }}</h4>
                <p class="leading-[2]" v-html="author.review" />
              </div>
            </div>

            <div v-if="bookInfo[0].news.length" class="mb-[50px]">
              <h4 class="text-[14px] sm:text-[15px] font-bold pb-[12px] mb-[12px] leading-[1.4] border-b border-b-black border-dotted">ニュース</h4>
              <ul>
                <li v-for="news in bookInfo[0].news" :key="news.booknewsID" class="mb-[10px] pb-[10px] border-b border-b-[#ccc] border-dotted">
                  <p class="inline" v-html="news.booknewsText" />
                  <a v-if="news.booknewsURL" :href="news.booknewsURL" target="_blank" class="inline-block text-[12px] font-semibold ml-[10px] text-afgreen">詳しくはこちら <span class="translate-y-[-1px] relative inline-block w-[6px] h-[6px] border-t-[2px] border-r-[2px] border-solid border-t-afgreen border-r-afgreen rotate-45" /></a>
                </li>
              </ul>
            </div>

            <ul class="mb-[30px] mx-[-8px] [&>li]:p-[8px]">
              <li v-if="bookInfo[0].bookLinksURL">
                <ButtonRounded text="ご購入はこちら" :url="bookInfo[0].bookLinksURL" icon="external" />
              </li>
              <li v-if="bookInfo[0].bookBrowseURL">
                <ButtonRounded :text="generateLabel()" :url="bookInfo[0].bookBrowseURL" icon="external" />
              </li>
            </ul>
          </div>
        </div>

        <Sidebar />
      </div>
    </div>
  </div>
</template>
